/* global require */
import * as csv from 'papaparse'
const downloadjs = require('downloadjs')
const YAML = require('json2yaml')

function taskToData(task) {
  const data = []
  task.Components.forEach((elm, elmIndex) => {
    if (!elm.Value || elm.Value.length === 0) elm.Value = {}
    if (!['image', 'textBlock'].includes(elm.Type)) {
      data[elmIndex] = [elm.Prompt]
    } else {
      data[elmIndex] = null
    }
    Object.keys(elm.Value).forEach((valIndex) => {
      valIndex = Number(valIndex)
      let val = elm.Value[valIndex]
      if (val) {
        if (elm.Type === 'tableInput') {
          data[elmIndex][valIndex + 1] = (tableToCSV(elm, valIndex))
        } else if (elm.Type === 'checklist') {
          val = Object.values(val).map((isChecked, i) => `${elm.Options[i]}: ${isChecked ? 'complete' : 'incomplete'}`)
          data[elmIndex][valIndex + 1] = (val.join(', '))
        } else {
          data[elmIndex][valIndex + 1] = (val.join(', '))
        }
      }
      else data[elmIndex][valIndex + 1] = ''
    })
  })
  const filteredData = []
  const maxLength = Math.max(...data.map(e => e?.length ?? 0))
  for (let i = 0; i < data.length; i++) {
    if (!data[i]) data[i] = []
    for (let j = 0; j < maxLength; j++) {
      if (!filteredData[i]) filteredData[i] = []
      filteredData[i][j] = data?.[i]?.[j] ?? ''
    }
  }
  console.log(filteredData)
  return {
    List: filteredData,
    CSV: filteredData[0] ? csv.unparse(filteredData[0].map((col, i) => filteredData.map(row => row[i]))) : '', //transpose array before outputting
    Raw: task.Components
  }
}

export function generateTaskDownload(task, clientName) {
  download(taskToData(task).CSV, `${clientName}-${task.Name}`, 'CSV')
}

export async function generateClientDownload(sections, clientName, clientRef) {
  var JSZip = require('jszip')
  const zip = new JSZip()
  const data = await Promise.all(Object.values(sections).map(async section => {
    const sectionFolder = zip.folder(section.Name)
    const sectionData = Promise.all(Object.values(section.Data).map(async task => {
      const taskData = (await clientRef.collection('Templates').doc(task.Ref).get()).data()
      const Data = taskToData(taskData)
      sectionFolder.file(`${task.Name}.csv`, Data.CSV,)
      return {
        Data,
        Name: taskData.Name
      }
    }))
    return {
      Name: section.Name,
      Tasks: await sectionData
    }
  }))
  console.log(JSON.stringify(data))
  const zipBlob = await zip.generateAsync({ type: 'blob' })
  console.log(zipBlob)
  downloadjs(zipBlob, `${clientName}-onboarding-data.zip`)
  /* return ['JSON', 'YAML'].map(e => ({
    content: e,
    action: () => {
      download(data, clientName, e)
      return true
    }
  }))*/
}

/*export async function generateClientDownload(sections, clientName, clientRef) {
  const data = await Promise.all(Object.values(sections).map(async section => {
    const sectionData = Promise.all(Object.values(section.Data).map(async task => {
      const taskData = (await clientRef.collection('Templates').doc(task.Ref).get()).data()
      return {
        Data: taskToData(taskData),
        Name: taskData.Name
      }
    }))
    return {
      Name: section.Name,
      Tasks: await sectionData
    }
  }))
  console.log(JSON.stringify(data))

  return ['JSON', 'YAML'].map(e => ({
    content: e,
    action: () => {
      download(data, clientName, e)
      return true
    }
  }))
}*/

export function download(data, filename, type) {
  if (type === 'JSON') {
    const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(data, null, 2))
    downloadjs(dataStr, `${filename}-onboarding-data.json`)
  } else if (type === 'YAML') {
    const dataStr = 'data:text/yaml;charset=utf-8,' + encodeURIComponent(YAML.stringify(data))
    downloadjs(dataStr, `${filename}-onboarding-data.yaml`)
  } else if (type === 'CSV') {
    const dataStr = 'data:text/csv;charset=utf-8,' + encodeURIComponent(data)
    downloadjs(dataStr, `${filename}-data.csv`)
  }
}


export function tableToCSV(elm, valIndex) {
  Object.values(elm.Table).forEach((row, rowIndex) => {
    Object.values(row).forEach((col, colIndex) => {
      if (!elm.Value) elm.Value = []
      if (!elm.Value[valIndex]) elm.Value[valIndex] = []
      if (!elm.Value[valIndex][rowIndex]) elm.Value[valIndex][rowIndex] = []
      if (!elm.Value[valIndex][rowIndex][colIndex]) elm.Value[valIndex][rowIndex][colIndex] = []
      elm.Value[valIndex][rowIndex][colIndex].Prompt = elm.Table[rowIndex][colIndex].Prompt
    })
  })
  return csv.unparse(Object.values(elm.Value[valIndex]).map(e => Object.values(e).map(t => {
    if (t.Prompt) return t.Prompt
    return t.Value
  })))
}